import apiClient from '@/api/apiClient';
import { handleError, getAuthData, prepareModel, validateId } from '../../utils/storeHelpers';

export default {
  namespaced: true,
  state: {
    schema: {},
    dataCrud: [],
    isNewRecord: true,
    status: '',
  },

  getters: {
    schema: (state) => state.schema,
    dataCrud: (state) => state.dataCrud,
    isNewRecord: (state) => state.isNewRecord,
    status: (state) => state.status,
  },

  mutations: {
    SET_SCHEMA(state, schema) {
      state.schema = schema;
    },
    SET_RECORDS(state, { recordsData }) {
      state.dataCrud = Array.isArray(recordsData?.dataCrud) ? recordsData.dataCrud : [];
      state.isNewRecord = Boolean(recordsData?.isNewRecord);
    },
    SET_STATUS(state, status) {
      state.status = status;
    },
  },

  actions: {
    async fetchSchema({ commit }) {
      try {
        commit('SET_STATUS', 'loading');
        const responses = await Promise.all([
          apiClient.anxALxLaborSchema(),
          apiClient.catOccupation(),
          apiClient.catLaborType(),
          apiClient.catAgeInterval(),
          apiClient.catDuration(),
          apiClient.catLaborLeave(),
          apiClient.catLaborLeaveWhy(),
        ]);
        const [
          schemaRes,
          catOccupation,
          catLaborType,
          catAgeInterval,
          catDuration,
          catLaborLeave,
          catLaborLeaveWhy,
        ] = responses.map((res) => res?.data ?? {});

        let id1 = 'G';
        const resCat6 = await apiClient.catLevelDescription(id1);
        const catLevelDescriptionG = resCat6.data.data;

        let id2 = 'H';
        const resCat7 = await apiClient.catLevelDescription(id2);
        const catLevelDescriptionH = resCat7.data.data;

        if (!schemaRes.formCrud) throw new Error('Estructura de schema inválida.');

        const schema = structuredClone(schemaRes);
        schema.formCrud.back_labor_occupation_id.items = catOccupation.data ?? [];
        schema.formCrud.labor_type_labor_type_id.items = catLaborType.data ?? [];
        schema.formCrud.back_labor_age_beginning.items = catAgeInterval.data ?? [];
        schema.formCrud.back_labor_duration_id.items = catDuration.data ?? [];
        schema.formCrud.back_labor_adaptation_level_id.items = catLevelDescriptionG;
        schema.formCrud.back_labor_relationship_peer_level_id.items = catLevelDescriptionG;
        schema.formCrud.back_labor_relationship_authority_level_id.items = catLevelDescriptionG;
        schema.formCrud.back_labor_performance_level_id.items = catLevelDescriptionH;
        schema.formCrud.back_labor_satisfaction.items = catLevelDescriptionH;
        schema.formCrud.labor_leave_labor_leave_id.items = catLaborLeave.data ?? [];
        schema.formCrud.labor_leave_why_labor_leave_why_id.items = catLaborLeaveWhy.data ?? [];

        commit('SET_SCHEMA', schema);
      } catch (error) {
        handleError(error, commit);
      }
    },

    async fetchRecords({ commit, rootState }) {
      try {
        const { clinicalHistories_id, institutions_profes_id } = getAuthData(rootState);
        const res = await apiClient.modelANxALxLabor(clinicalHistories_id, institutions_profes_id);
        const recordsData = res?.data?.data ?? [];
        commit('SET_RECORDS', { recordsData });
        commit('SET_STATUS', 'loaded');
      } catch (error) {
        handleError(error, commit);
      }
    },

    async createRecord({ commit, rootState }, { model }) {
      try {
        commit('SET_STATUS', 'create');
        const preparedModel = prepareModel(rootState, model);
        await apiClient.createANxALxLabor(preparedModel);
        commit('SET_STATUS', 'success');
      } catch (error) {
        handleError(error, commit);
      }
    },

    async updateRecord({ commit, rootState }, { model }) {
      try {
        commit('SET_STATUS', 'update');
        const { clinicalHistories_id } = getAuthData(rootState);
        const preparedModel = prepareModel(rootState, model);
        await apiClient.updateANxALxLabor(clinicalHistories_id, preparedModel);
        commit('SET_STATUS', 'success');
      } catch (error) {
        handleError(error, commit);
      }
    },

    async removeRecord({ commit, rootState }, { id }) {
      try {
        commit('SET_STATUS', 'remove');
        const { clinicalHistories_id, institutions_profes_id } = getAuthData(rootState);
        validateId(id);
        await apiClient.deleteANxALxLabor(id, clinicalHistories_id, institutions_profes_id);
        commit('SET_STATUS', 'success');
      } catch (error) {
        handleError(error, commit);
      }
    },
  },
};
